<template>
  <div class="row">
    <div class="col-md-12 pad-to-5">
      <digital-signage-form :route="route" @on-submit="onUserSubmit"></digital-signage-form>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Select, Option} from 'element-ui'
  import DigitalSignageForm from './DigitalSignageForm.vue'
  Vue.use(Select)
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      DigitalSignageForm
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        digitalSignageModel: {},
        modelValidations: {
          required: {
            required: true
          }
        }
      }
    },
    methods: {
      onUserSubmit (model, isValid) {
        this.digitalSignageModel = model
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Screens/DigitalSignage/DigitalSignageAdd.vue